module.exports = __webpack_public_path__ + "static/media/cooking-salon-ad3.d4527ee2.jpg";